/* Keep the approved grain on warm paper surfaces, including refreshed drawers. */
(() => {
  const surfaces = 'body,main,section,header,footer,div,article,aside,nav,li,form,fieldset,details,summary,dialog,table,thead,tbody,tr,td,th,dl,dt,dd';
  const media = '.card__inner,.card__media,.product__media,.product-media-container,.thumbnail,.cabane-recommendations__image,.setup-bundle__media,.lcg-wishlist__item-image,.lcg-search__result-image';
  const pending = new Set();
  let scheduled = false;

  function mark(element) {
    if (!(element instanceof HTMLElement) || !element.matches(surfaces)) return;
    const style = getComputedStyle(element);
    const channels = style.backgroundColor.match(/[\d.]+/g)?.map(Number);
    const [r=0,g=0,b=0,a=1] = channels || [];
    const photographic = /url\(/.test(style.backgroundImage) && !style.backgroundImage.includes('cabane-street-grain.svg');
    const paper = a >= .99 && r >= 230 && r >= g && g >= b && r-b >= 10 && r-b <= 45;
    element.toggleAttribute('data-cabane-paper-grain',paper && !photographic && !element.closest(media));
  }

  function markTree(root) {
    mark(root);
    root.querySelectorAll?.(surfaces).forEach(mark);
  }

  function schedule(element) {
    if (!(element instanceof HTMLElement)) return;
    pending.add(element);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      for (const root of pending) if (root.isConnected) markTree(root);
      pending.clear();
    });
  }

  function boot() {
    markTree(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') mark(record.target);
        else record.addedNodes.forEach(schedule);
      }
    });
    observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style']});
    document.addEventListener('shopify:section:load',event=>schedule(event.target));
    window.addEventListener('load',()=>schedule(document.body),{once:true});
    // A breakpoint can change a transparent panel into an opaque paper surface.
    const mobile = window.matchMedia('(max-width: 749px)');
    mobile.addEventListener('change',()=>schedule(document.body));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
